import { isSSR } from 'app/packages/components';

import { $global } from './$global';
import createClientConfig from './createClientConfig';

// ---

const {
  setConfig: saveMatchGridTemplates,
  getConfig: getMatchGridTemplates,
} = createClientConfig<MatchGridTemplates>('MATCH_GRID_TEMPLATES');

export { saveMatchGridTemplates, getMatchGridTemplates };

export function getMatchGridTemplateByName<T extends keyof MatchGridTemplates, D = void>(
  name: T,
  defaultValue?: D,
): MatchGridTemplates[T] | (D extends void ? object : D) {
  let template;

  if (isSSR) {
    template = $global('MATCH_GRID_TEMPLATES');
  }
  else {
    template = getMatchGridTemplates();
  }

  if (!template) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return defaultValue === undefined ? {} : defaultValue;
  }

  return template[name];
}

type MatchGridTemplates = {
  version: number;
  BALANCING_STAKE_TYPES_CONF: { price: number[] };
  GRID_SLOT_FAMILY_CONF: {
    SLOT_FAMILY_CORRECT_SCORE_SINGLE_BET: number[];
    SLOT_FAMILY_MULTI: number[];
    SLOT_FAMILY_SINGLE: number[];
  };
  GRID_SLOT_NAME_CONF: Record<string, { ru: string; en: string }>;
  GRID_SLOT_SEQUENCING_CONF: Record<string, number | { index: number; params: string[] }>;
  GRID_SLOT_TYPES_CONF: Record<
    string,
    Record<
      string,
      Record<
        string,
        number[] | ({ slotType: number; filter: { team: number } })[]
        >
      >
    >;
  LINE_STAKE_TYPE_CONF: Record<
    string,
    ({
      lineId: number;
      stakeTypes: number[] | ({ stakeType: number; filter: { period: number } })[];
    })[]
  >;
  LINE_STAKE_TYPE_GROUP_CONF: Record<string, ({
    lineId: number;
    groupId: number;
    stakeType: number;
    filter?: Partial<{ duration: number; from: number; period: number }>;
  })[]>;
  SPORT_LINES_CONF: Record<string, {
    id: number;
    index: number;
    isMain: boolean;
    names: { ru: string; en: string };
  }[]>;
  STAKE_RENDERER_CONF: Record<string, number[]>;
  STAKE_TYPE_GROUP_BY_SPORT_CONF: Record<string, number[]>;
  STAKE_TYPE_GROUP_CONF: Record<string, { names: { ru: string; en: string } }>;
  STAKE_TYPE_GROUP_PRIORITIES_CONF: Record<string, number>;

  //! TODO: следующие конфиги не используются
  INNER_LINES_SCORES_CONF: Record<
    string,
    Record<
      string,
      { periodNumber: number; periodType: number; pointType: number }
      >
    >;
  SPORT_NAVIGATION_STYLES: Record<string, unknown>;
  TOURNAMENT_NAVIGATION_STYLES: Record<string, unknown>;
  UNION_NAVIGATION_STYLES: Record<string, unknown>;

  //! TODO: Следующие конфиги были удалены в задаче SITE-436
  // Обязательно узнать, зачем они были нужны
  MATCH_CONTENT_SLOT_FAMILY_CONF: {
    SLOT_FAMILY_CORRECT_SCORE_SINGLE_BET: number[];
    SLOT_FAMILY_HANDICAP: number[];
    SLOT_FAMILY_SINGLE_MULTI_LINE: number[];
    SLOT_FAMILY_SINGLE_ONE_LINE_2W: number[];
    SLOT_FAMILY_SINGLE_ONE_LINE_3W: number[];
    SLOT_FAMILY_TOTAL: number[];
  };
  MATCH_CONTENT_SLOT_SEQUENCING_CONF: Record<
    string,
    Record<string, number | { index: number; params: string[] }>
  >;
  MATCH_CONTENT_SLOT_TYPES_CONF: Record<
    string,
    Record<string, number[] | ({ slotType: number; filter: { period: number } })[]>
  >;
  MATCH_CONTENT_STAKE_FILTERS_CONF: Record<string, Record<string, {
    block: boolean;
    index: number;
    names: { ru: string; en: string };
    values: Record<string, {
      block: boolean;
      index: number;
      names: { ru: string; en: string };
      title: { ru: string; en: string };
      types: number[];
    }>;
  }>>;
};
